<template>
  <div class="vx-row">
    <div class="vx-col sm:w-2/3 content-wrapper">
      <div class="flex mb-4">
        <div class="lg:w-full w-full bg-grid-color h-12">
          <vs-card class="px-5 py-5">
            <div v-if="specialLink" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Link</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-button
                  :href="splitLink(form.register_link)"
                  target="_blank"
                  color="primary"
                  type="flat"
                  >Go to Event with Token
                  <i class="ml-2 fas fa-external-link-alt"></i
                ></vs-button>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Promotion Title</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="promotitle"
                  class="w-full"
                  v-model="form.promotitle"
                  :maxlength="200"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('promotitle')"
                >
                {{ splitError(errors.first('promotitle'), 'promotitle') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Title</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Shown instead of Title where space is limited
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="promoshortname"
                  class="w-full"
                  v-model="form.promoshortname"
                  :maxlength="200"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('promoshortname')"
                >
                  {{ splitError(errors.first('promoshortname'), 'promoshortname') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  class="w-full"
                  v-model="form.promodesc"
                  :maxlength="200"
                />
              </div>
            </div>


            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Period</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!-- <flat-pickr
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                  v-model="form.date_start"
                  placeholder="Date Time Start"
                />
                <span class="mx-4">to</span>
                <flat-pickr
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                  v-model="form.date_end"
                  placeholder="Date Time End"
                /> -->
                <flat-pickr
                  :config="configs.start"
                  v-model="form.date_start"
                  @on-change="onStartChange"
                  placeholder="Date Time Start"
                />
                <span class="mx-4">to</span>
                <flat-pickr
                  :config="configs.end"
                  v-model="form.date_end"
                  @on-change="onEndChange"
                  placeholder="Date Time End"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <vx-tooltip text="Number of times this can be used" class="" position="top">
                  <span>Quantity</span>
                  <i class="ml-2 fa fa-question-circle" aria-hidden="true"></i>
                </vx-tooltip> -->
                <span>Quantity</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Number of times this can be used
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6 vx-align-center">
                  <div class="vx-col" style="display:inline-block; padding-top:15px;">
                    <vs-radio v-model="isPromoLimited" vs-name="quantity" :vs-value="false">Unlimited</vs-radio>
                  </div>
                  <div class="vx-col" style="display:inline-block; padding-top:15px;">
                    <vs-radio v-model="isPromoLimited" vs-name="quantity" :vs-value="true">Limit usage</vs-radio>

                  </div>
                  <div class="vx-col">
                    <vs-input v-validate="{
                      required: isPromoLimited,
                      min_value: 1
                    }" name="qty" id="qty" v-on:blur="validateQuantity()" class="w-full" v-model="form.qty" :disabled="!isPromoLimited"
                      onkeypress="return /^[0-9]/i.test(event.key)" onpaste="return false" />
                    <span class="text-danger text-sm" v-show="errors.has('qty')">
                      {{ splitError(errors.first("qty"), 'qty') }}
                    </span>
                  </div>
                  <div class="vx-col" style="display:inline-block; padding-top:15px;">
                    times
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col">
                    <vs-input
                      v-if="form.disctype === 'percent'"
                      v-validate="{ required: true, max_value: 100 }"
                      name="discvalue"
                      v-model="form.discvalue"
                      style="width:120px;"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                      onpaste="return false"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('discvalue')"
                    >
                      {{ splitError(errors.first("discvalue"), 'discvalue') }}
                    </span>
                    <vs-input
                      v-if="form.disctype === 'amount'"
                      v-validate="{ required: true }"
                      name="discvalue"
                      v-model="form.discvalue"
                      style="width:120px;"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                    />
                  </div>

                  <div class="vx-col sm:w-2/3">
                    <ul style="display:inline-block; padding-top:15px;">
                      <li style="display:inline-block">
                        <vs-radio
                          v-model="form.disctype"
                          vs-value="percent"
                          class="mx-3"
                          >Percent (%)</vs-radio
                        >
                      </li>
                      <li style="display:inline-block">
                        <vs-radio
                          v-model="form.disctype"
                          vs-value="amount"
                          class="mx-3"
                        >
                          {{ currency }}
                        </vs-radio>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.disctype" vs-value="percent"
                      >Percent (%)</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.disctype" vs-value="amount">
                      {{ currency }}
                    </vs-radio>
                  </li>
                </ul> -->
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount from</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul style="display:inline-block;">
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="fullprice"
                      class="mr-3"
                      >Full Price</vs-radio
                    >
                  </li>
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="currentprice"
                      class="mx-3"
                      >Current Price</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount On</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.disclevel" :vs-value="1">All Tickets</vs-radio>
                  </li>
                  <li>
                    <vs-radio v-model="form.disclevel" :vs-value="2"
                      >Selective Tickets</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="form.disclevel == 2" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                Select the tickets the discount is applicable to
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="centerx">
                  <li
                    v-for="(item, i) in productList"
                    :key="i"
                    style="margin:12px 0;"
                  >
                    <vs-checkbox v-model="item.selected">
                      <div>{{
                        item.pro_name
                      }}</div>
                      <div style="font-size: 0.75rem; color:#aaa;">{{ item.pro_shortdesc }}</div>
                    </vs-checkbox>
                  </li>
                </ul>
                <vs-button
                  v-if="!hideSeemore && totalTicket > 10"
                  type="flat" class="mr-3 mb-2 p-1"
                  @click="seeAllTicket"
                >
                  See more
                </vs-button>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Note attached to order (Internal use)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  name="promonote"
                  class="w-full"
                  v-model="form.promonote"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Status</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="promo_status"
                      v-model="form.promo_status"
                      :vs-value="1"
                      >Enabled</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="promo_status"
                      v-model="form.promo_status"
                      :vs-value="0"
                      >Disabled</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div style="height:30px;"></div>
            <div class="vx-row pt-2 mt-0">
              <div class="vx-col w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="validateForm"
                  >Save
                </vs-button>

                <vs-button class="mr-3 mb-2" type="border" @click="cancel()"
                  >Cancel
                </vs-button>
              </div>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
    <div class="vx-col sm:w-1/3 pl-4 content-wrapper" style="width:400px">
      <div class="con-vs-card px-5 py-5">
        <div style="display:flex;justify-content:space-between;">
          <div>
            <div>{{ form.used || 0 }} used</div>
          </div>
          <div>
            <div v-if="isPromoLimited">{{ form.qty }}</div>
            <div v-else>Unlimited</div>
          </div>
        </div>

        <div>
          <vs-progress :percent="(form.used || 0) * 100 / (form.qty || 1)"
            color="primary"></vs-progress>
        </div>
        <div v-if="isPromoLimited && !isNaN(parseInt(form.qty))" style="font-size: 0.75rem; color: #626262">
          {{ form.qty ? (form.qty - (form.used || 0)) : 'N/A' }} remaining
        </div>
      </div>
      <div class="con-vs-card mt-5 px-5 py-5">
        <div class="vx-row pt-2 mt-0 pr-4" style="flex-wrap: nowrap;">
          <div class="vx-col  pr-0" style="flex-grow: 1;">
            <vs-input
              class="w-full"
              style="border-top-right-radius: 0;border-bottom-right-radius: 0;"

              :value="splitLink(form.register_link)"
              :maxlength="200"
            />
            <input type="text" style="    position: fixed;right: -800px;" id="copylink" :value="splitLink(form.register_link)"/>
          </div>
          <div class="vx-col pl-0 pr-0" style="    flex: 0 0 auto;">
            <vs-button class="mb-2" style="border-top-left-radius: 0;border-bottom-left-radius: 0;    transform: translateX(-2px);" type="border" @click="copylink();"
                >
                <div class="help-icon-text text-primary">
                  <i class="fa fa-clipboard" aria-hidden="true"></i>
                  Copy Link
                </div>
              </vs-button>
          </div>
        </div>

      </div>
      <div class="con-vs-card mt-5 px-5 py-5">
        <div >
          <div>
            <div style="font-size: 0.75rem; color: #626262">Preview</div>
          </div>
          <div style="font-size: 1.25rem; color: #000" class="mt-2">
            Special Link
          </div>
          <div style="font-size: 2rem; color: #000">
            {{form.promotitle}}
          </div>
          <div>
            {{form.promoshortname}}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";
import { timezones } from "@/utils/Timezones";

import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    VxAutoSuggest,
    flatPickr
  },
  props: ["promocode_id"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      },
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data() {
    return {
      isPromoLimited: false,
      form: {
        promo_id: null,
        promo_type: null,
        promotitle: null,
        promoshortname: null,
        promodesc: null,
        disctype: "percent",
        discvalue: null,
        discfrom: null,
        disclevel: 1,
        applyto: null,
        date_start: null,
        date_end: null,
        qty: null,
        used: null,
        pccode: null,
        token: null,
        promonote: null,
        promo_status: null,
        weight: null,
        selective: []
      },
      productList: [],
      item: {
        selected: null
      },
      currency: 'THB',
      configs: {
        basic: {},
        start: {
          minDate: null,
          maxDate: null,
          enableTime: true,
          dateFormat: 'Y-m-d H:i'
        },
        end: {
          minDate: null,
          enableTime: true,
          dateFormat: 'Y-m-d H:i'
        },
      },
      specialLink: false,
      hideSeemore: false,
      totalTicket: 0,
      per_page: 10,
    };
  },
  watch: {
    isPromoLimited: function() {
      if(!this.isPromoLimited) {
        // this.form.limit_usage = ''
      }
      else {
        setTimeout(()=>{
          document.getElementById('qty').focus()
        },300)
      }
    }
  },
  created() {
    let data = {
      e: this.e
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

      const paramsData = params + `&perPage=${this.per_page}`

    Service.Product.gets(paramsData).then(res => {
      this.productList = res.data.rows.map(item => {
        return { ...item, selected: false };
      });

      this.totalTicket = res.data.total
      if (res.data.total > this.per_page) {
        this.hideSeemore = false;
      } else {
        this.hideSeemore = true;
      }

      Service.Bootsale.getPromo(this.promocode_id, params)
        .then(promo => {
          this.form = promo.data.promo;
          this.form.disclevel = promo.data.promo.disclevel === 'order' ? 1: 2;

          console.log(this.form.date_start)

          this.form.date_start = moment(promo.data.promo.date_start).format(
            "YYYY-MM-DD HH:mm"
          );
          this.form.date_end = moment(promo.data.promo.date_end).format(
            "YYYY-MM-DD HH:mm"
          );
          // console.log(this.form.date_start);
          // console.log(promo.data.promo.date_start);

          this.isPromoLimited = !!this.form.qty && this.form.qty !== 0;
          promo.data.relation.map(item => {
            if (item.applyto_tbl == "product") {
              let index = this.productList.findIndex(
                x => x.product_id == item.applyto_id
              );
              if (index >= 0) {
                this.productList[index].selected = true;
              }
            }
          });
        })
        .catch(error => {});
    });

    Service.Event.get(this.e)
      .then(res => {
        this.currency = res.data.event.currency
      })

    let special = this.$route.name
    console.log(special, 'special')
    if (special === 'special-links-detail') {
      this.specialLink = true
    }
    else {
      this.specialLink = false
    }

  },
  methods: {
    copylink() {
      // Get the text field
      var copyText = document.getElementById("copylink");

      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);

      // Alert the copied text
    },
    splitError(val, word) {
        if (!val) {
            return
        }
        else {
            const data = val.split(word)
            return data[0] + data[1]
        }
    },
    validateQuantity() {
      /* free event, max = 100 */
      this.$validator.validate('qty').then(result => {
        console.log('result', result)
        if (result) {
          // if form have no errors
          // this.submit();
        }
      });
      return;
    },
    validateForm() {
      // if(!this.isPromoLimited) {
      //   this.form.qty = 1
      // }
      this.$validator.validateAll().then(result => {
        if (result) {
          if(!this.isPromoLimited) {
            this.form.qty = null
          }
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    cancel() {
      const path = this.$route.name === 'special-links-promo-detail'
      this.$router.push(`/${path ? 'promotions': 'special-links'}?s=` + this.s + "&e=" + this.e);
    },
    submit() {
      this.form.e = this.e;

      this.form.date_start = moment(this.form.date_start).format(
            "YYYY-MM-DD HH:mm"
          );
      this.form.date_end = moment(this.form.date_end).format(
            "YYYY-MM-DD HH:mm");

      const selective = this.productList.filter(ele => ele.selected === true)
      this.form.selective = selective
      this.$vs.loading();

      const data = {
        ...this.form,
        selective: this.form.disclevel === 1 ? []: this.form.selective
      }


      Service.Bootsale.updatePromo(this.form.promo_id, data)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update promocode completed.",
              color: "success"
            });
          }
          const path = this.$route.name === 'special-links-promo-detail'
          this.$router.push(`/${path ? 'promotions': 'special-links'}?s=` + this.s + "&e=" + this.e);
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    onEndChange(selectedDates, dateStr, instance) {
      this.configs.start.maxDate = dateStr
    },
    onStartChange(selectedDates, dateStr, instance) {
      this.configs.end.minDate = dateStr
    },
    splitLink(val) {
      const data = val.split('token=')
      const path1 = data[0]
      const path2 = data[1]

      const bootsalesType = this.$route.name
      if (bootsalesType === 'special-links-promo-detail') {
        return val
      }
      else {
        return path1 + 'cmp=' + path2
      }
    },
    seeAllTicket() {
      let data = {
        e: this.e
      };
      let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

      const selectedid = this.productList.filter(item => item.selected).map(item => item.product_id)
      const paramsData = params + `&perPage=${this.totalTicket}`
        Service.Product.gets(paramsData).then(res => {
        this.productList = res.data.rows.map(item => {
          return { ...item, selected: selectedid.includes(item.product_id) };
        });
        this.hideSeemore = true

      })
    }
  }
};
</script>
